import { Link, useLocation } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { useCart } from "@shopify/hydrogen-react";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/studio", label: "Design Studio" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const Header = () => {
  const location = useLocation();
  const { totalQuantity } = useCart();

  return (
    <header className="border-b" style={{ borderColor: "var(--brand-border)" }}>
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="text-xl font-bold" style={{ fontFamily: "var(--font-heading)" }}>
          GeoForge3D
        </Link>

        <nav className="hidden md:flex items-center gap-6">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm transition-colors ${
                location.pathname === link.to
                  ? "font-semibold"
                  : "text-gray-600 hover:text-gray-900"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <Link to="/cart" className="relative p-2">
          <ShoppingCart className="h-5 w-5" />
          {(totalQuantity ?? 0) > 0 && (
            <span className="absolute -top-1 -right-1 bg-black text-white text-xs rounded-full h-4 w-4 flex items-center justify-center">
              {totalQuantity}
            </span>
          )}
        </Link>
      </div>
    </header>
  );
};

export default Header;
